import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable()
export class CategoryService {
  private categories = {};

  public constructor(
    private apiService: ApiService
  ) {
  }
  public async getCategories(options?): Promise<any> {
    if (this.categories && Array.isArray(this.categories) && this.categories.length > 0) return this.categories;

    let data = await this.apiService.call('categories', 'GET', options);
    data.forEach(item => this.categories[item.id] = item);

    return this.categories;
  }
}



// WEBPACK FOOTER //
// ./src/services/category.service.ts